import { connect } from 'react-redux';
import ListGroupPelanggaran from '../../../views/Student/displiner/ListGroupPelanggaran.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(ListGroupPelanggaran);
